// @flow
import { connect } from 'react-redux';

import InviteFriend from './InviteFriend';
import {
  customerExternalIdSelector,
  customerFullNameSelector,
  customerGivenNameSelector,
} from '../../modules/Customer/selectors';
import { referralBonusesSelector } from '../../modules/Bonuses';
import type { StateProps } from './InviteFriend';
import type { StateType } from '../../modules/reducers';
import config from '../../config';
import I18n from '../../lib/i18n';
import { dateUtils } from '../../lib/date-utils';

const mapStateToProps = (state: StateType): StateProps => {
  const referralBonuses = referralBonusesSelector(state);

  const endDateTimeLabel = referralBonuses?.endDateTime
    ? I18n.t('Dashboard.InviteFriend.endDateTime', {
        MGMEndDate: dateUtils.format(new Date(referralBonuses.endDateTime), 'P'),
      })
    : '';
  const additionalInfoLabel = config.MGM_DETAIL_LINK_URL ? I18n.t('Dashboard.InviteFriend.additionalInfo') : '';
  const text = `${endDateTimeLabel}${additionalInfoLabel}`;

  const infoDetail = text
    ? {
        text,
        linkText: I18n.t('Dashboard.InviteFriend.additionalInfoLink'),
        linkUrl: config.MGM_DETAIL_LINK_URL,
      }
    : null;

  return {
    code: customerExternalIdSelector(state),
    givenName: customerGivenNameSelector(state),
    infoDetail,
    referralBonuses,
    sender: customerFullNameSelector(state),
  };
};

export default connect(mapStateToProps)(InviteFriend);
